import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
// @mui
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Autocomplete from '@mui/material/Autocomplete';
import {
  endpoints,
  getFetcherPrams,
  getFetcherPrams2,
  postFetcher1,
  postPramsFetcher,
  postPramsFetcher1,
} from 'src/utils/axios';
import { RHFSelect } from 'src/components/hook-form';

// ----------------------------------------------------------------------

export default function CustomerReceivableTableToolbar({
  filters,
  onFilters,
  //
  canReset,
  onResetFilters,
  supplierData,
}) {
  const popover = usePopover();
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [tableData, setTableData] = useState([]);

  const handleFilterName = useCallback(
    (event) => {
      onFilters('name', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  const handleSupplierChange = (event) => {
    const supplierId = event.target.value;
    setSelectedSupplierId(supplierId);
  };

  const handleSupplierinputChange = async (values) => {
    const url = `${endpoints.supplier.fetchCustomers}/0/10`;
    // http://localhost:8443/api/v1/suppliers/search/0/10/?name=1&type=1

    const params = {
      code: values,
      type: 1,
    };

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    try {
      const systemData = await postPramsFetcher1(url, params, null, config);
      setTableData(systemData.data.content || []);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Stack
        spacing={2}
        alignItems={{ xs: 'flex-end', md: 'center' }}
        direction={{
          xs: 'column',
          md: 'row',
        }}
        sx={{
          p: 2.5,
          pr: { xs: 2.5, md: 1 },
        }}
      >
        <DatePicker
          label="Start date"
          value={filters.startDate}
          onChange={handleFilterStartDate}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
          sx={{
            maxWidth: { md: 200 },
          }}
        />

        <DatePicker
          label="End date"
          value={filters.endDate}
          onChange={handleFilterEndDate}
          slotProps={{ textField: { fullWidth: true } }}
          sx={{
            maxWidth: { md: 200 },
          }}
        />

        <Autocomplete
          options={tableData}
          getOptionLabel={(option) => option.name || ''}
          value={tableData.find((item) => item.id === selectedSupplierId) || null}
          onChange={(event, newValue) => {
            setSelectedSupplierId(newValue ? newValue.id : null);
            supplierData(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            handleSupplierinputChange(newInputValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Customer Name" fullWidth style={{ textAlign: 'left' }} />
          )}
          // isOptionEqualToValue={(option, value) => option.id === value.id}
          sx={{ width: 300 }}
        />

        {/* <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
          <TextField
            fullWidth
            value={filters.name}
            onChange={handleFilterName}
            placeholder="Search customer or po number..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              ),
            }}
          />

          <IconButton onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </Stack>

        {canReset && (
          <Button
            color="error"
            sx={{ flexShrink: 0 }}
            onClick={onResetFilters}
            startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
          >
            Clear
          </Button>
        )} */}
      </Stack>

      {/* <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:printer-minimalistic-bold" />
          Print
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:import-bold" />
          Import
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
          }}
        >
          <Iconify icon="solar:export-bold" />
          Export
        </MenuItem>
      </CustomPopover> */}
    </>
  );
}

CustomerReceivableTableToolbar.propTypes = {
  canReset: PropTypes.bool,
  filters: PropTypes.object,
  onFilters: PropTypes.func,
  onResetFilters: PropTypes.func,
  supplierData: PropTypes.func,
};
